import { render, staticRenderFns } from "./modal-listacliente.vue?vue&type=template&id=4fff47ed"
import script from "./modal-listacliente.vue?vue&type=script&lang=js"
export * from "./modal-listacliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports